// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1S6eA","title":"styles_title__Ln03L"};